// Shell — standalone layout matching OMNI's sidebar + header + content pattern

import { useEffect, type ReactNode } from "react";
import { useLocation } from "wouter";
import { usePeerStore } from "../stores/peers.js";

interface NavItem {
	path: string;
	label: string;
	adminOnly?: boolean;
}

const NAV_ITEMS: NavItem[] = [
	{ path: "/", label: "Dashboard", adminOnly: true },
	{ path: "/my-peers", label: "My Peers" },
	{ path: "/audit", label: "Audit Log", adminOnly: true },
];

interface ShellProps {
	children: ReactNode;
}

export function Shell({ children }: ShellProps) {
	const [location, setLocation] = useLocation();
	const user = usePeerStore((s) => s.user);
	const fetchUser = usePeerStore((s) => s.fetchUser);

	useEffect(() => {
		fetchUser();
	}, [fetchUser]);

	const visibleNav = NAV_ITEMS.filter((item) => !item.adminOnly || user?.isAdmin);

	return (
		<div className="shell">
			<header className="shell-header">
				<div className="shell-header-left">
					<span className="shell-title">WireGuard Manager</span>
				</div>
				<div className="shell-header-right">
					{user && <span className="shell-user">{user.displayName}</span>}
					{user && (
						<form method="POST" action="/auth/logout" style={{ display: "inline" }}>
							<button className="btn btn-sm" type="submit">
								Logout
							</button>
						</form>
					)}
					{!user && (
						<a className="btn btn-sm btn-primary" href="/auth/login">
							Login
						</a>
					)}
				</div>
			</header>

			<nav className="shell-sidebar">
				<div className="shell-nav">
					{visibleNav.map((item) => (
						<button
							key={item.path}
							className="shell-nav-item"
							data-active={location === item.path}
							onClick={() => setLocation(item.path)}
							type="button"
						>
							{item.label}
						</button>
					))}
				</div>
			</nav>

			<main className="shell-content">{children}</main>
		</div>
	);
}
